import * as React from 'react';
import { useState } from "react";
import MuiDrawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function CarbonReportingPage() {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [framework, setFramework] = useState([])
    const [link, setLink] = useState("")

    function handleJump() {
        if (framework == '') {
            alert("Please Choose one!")
        } else {
            window.open(framework, 'target', '')

            if (framework == 'https://www.globalreporting.org/standards/download-the-standards/') {
                setLink("https://www.globalreporting.org/")
            } else if (framework == 'https://www.sasb.org/standards/download/?lang=en-us') {
                setLink("https://www.sasb.org/")
            } else if (framework == 'https://www.integratedreporting.org/resource/international-ir-framework/') {
                setLink("https://integratedreporting.org/")
            } else if (framework == 'https://assets.bbhub.io/company/sites/60/2021/10/FINAL-2017-TCFD-Report.pdf') {
                setLink("https://www.fsb-tcfd.org/")
            } else if (framework == 'https://www.cdp.net/en') {
                setLink("https://www.cdp.net/en")
            } else if (framework == 'https://www.cdsb.net/sites/default/files/cdsb_framework_2022.pdf') {
                setLink("https://www.cdsb.net/")
            } else if (framework == 'https://www.ungpreporting.org/wp-content/uploads/UNGPReportingFramework_2017.pdf') {
                setLink("https://www.ungpreporting.org/")
            } else {
                setLink("")
            }
        }
    }

    return (
        <Box sx={{ display: 'flex', height: '100%'}}>
            {/* Side bar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                        {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>

                <Divider />

                {/* Navigations to different pages */}
                <List component="nav">
                    <ListItemButton href="/Dashboard/Carbon" >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Carbon Calculation" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Carbon/Reporting" >
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Carbon Reporting" />
                    </ListItemButton>
                </List>
            </Drawer>
                    
            <Box sx={{ width: '90%' }}>
                {/* Title */}
                <Typography
                    component="h1"
                    variant="subtitle1"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                    >
                    Ambient / Carbon Measurement / Reporting
                </Typography>
                <Typography
                    component="h1"
                    variant="h4"
                    color="inherit"
                    noWrap
                    sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                    >
                    Carbon Reporting
                </Typography>

                <Box sx={{ ml: 6, display: "flex" }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ mt: 3, ml: 2 }}
                        >
                        View one of the SGX-approved reporting frameworks: 
                    </Typography>

                    <FormControl sx={{ ml: 1, mt: 2, minWidth: 200 }} variant= "standard">
                        <Select native defaultValue="" label="Feed" disableUnderline
                            theme={theme}
                            sx={{
                                borderRadius: 25,
                                backgroundColor: theme.palette.background.default,
                                padding: "6px 15px",
                            }}
                            value={framework}
                            onChange={(e) => {setFramework(e.target.value)}}>
                            
                            <option aria-label="None" value=""></option>
                            <option value="https://www.globalreporting.org/standards/download-the-standards/">Global Reporting Initiative (GRI)</option>
                            <option value="https://www.sasb.org/standards/download/?lang=en-us">Sustainability Accounting Standards Board (SASB)</option>
                            <option value="https://www.integratedreporting.org/resource/international-ir-framework/">International Integrated Reporting Council (IIRC)</option>
                            <option value="https://assets.bbhub.io/company/sites/60/2021/10/FINAL-2017-TCFD-Report.pdf">Task Force on Climate-related Financial Disclosures (TCFD)</option>
                            <option value="https://www.cdp.net/en">CDP Global (CDP)</option>
                            <option value="https://www.cdsb.net/sites/default/files/cdsb_framework_2022.pdf">Climate Disclosure Standards Board (CDSB)</option>
                            <option value="https://www.ungpreporting.org/wp-content/uploads/UNGPReportingFramework_2017.pdf">UN Guiding Principles Reporting Framework</option>
                        </Select>
                    </FormControl>

                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2, ml: 2, borderRadius: 5 }}
                        position="absolute"
                        onClick={handleJump}
                    >
                        Download
                    </Button>
                </Box>

                {link? (
                <Box sx={{ ml: 8, mt: 5,  display: "flex" }}>
                    <Typography variant="subtitle1">Learn more: <a href={framework}>{framework}</a></Typography>
                </Box>
                ) : (<div></div>)}
            </Box>
        </Box>
    )
}